import React from 'react';
import { Alert, Box, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { DischargePatient } from '~/types/discharge';
import { useDischargeContext } from '~/hooks/discharge/useDischargeContext';

interface ChecklistItem {
  key: string;
  label: string;
}

function checklistFor(patient: DischargePatient): ChecklistItem[] {
  const items: ChecklistItem[] = [
    { key: 'transportation', label: 'Transportation secured' },
  ];
  if (patient.disposition === 'home_health') {
    items.push(
      { key: 'dme', label: 'DME ordered' },
      { key: 'meals', label: 'Medically tailored meals arranged' },
    );
  }
  return items;
}

interface Props {
  patient: DischargePatient;
}

const MonitorSection: React.FC<Props> = ({ patient }) => {
  const { toggleMonitorCheck } = useDischargeContext();
  const checks = patient.monitorChecks ?? [];
  const items = checklistFor(patient);

  return (
    <Box>
      <Alert severity="success" sx={{ mb: 2 }}>
        <Typography variant="body2" fontWeight={600}>
          No adverse changes in the past 24 hrs
        </Typography>
      </Alert>

      <Stack spacing={0.5}>
        {items.map(item => (
          <FormControlLabel
            key={item.key}
            control={
              <Checkbox
                size="small"
                checked={checks.includes(item.key)}
                onChange={() => toggleMonitorCheck(patient.id, item.key)}
              />
            }
            label={item.label}
            slotProps={{ typography: { variant: 'body2' } }}
          />
        ))}
      </Stack>
    </Box>
  );
};

export default MonitorSection;
